import React, { useEffect, useState, useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import Papa from 'papaparse';
import Encoding from 'encoding-japanese';
import { Container, CircularProgress, Typography, Paper, Toolbar, Button, Grid, Divider } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from 'redux';
import { ShopActions, NotificationActions } from '../../../store';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import SaveIcon from '@material-ui/icons/Save';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px'
    },
    msg_field: {
        margin: "30px auto",
        width: "80%"
    },
    read_file: {
        margin: "50px auto",
        width: "100%",
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const baseStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#bdbdbd",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out"
};

//ドロップ可能な場合
const acceptStyle = {
    borderColor: "#afeeee",
    backgroundColor: "#e0ffff"
};

//ドロップ拒否の場合
const rejectStyle = {
    borderColor: "#ff7f50",
    backgroundColor: "#ffe4e1"
};

const shopsSelector = (state) => state.Shops;
const identitySelector = (state) => state.Identity;

const ShopBulkRegist = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const shopActions = bindActionCreators(ShopActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(shopsSelector);
    const { token } = useSelector(identitySelector);

    // React Hook Form
    const { handleSubmit } = useForm();

    const { classes } = props;

    const { acceptedFiles, getRootProps, getInputProps, isDragAccept, isDragReject } = useDropzone();

    const style = useMemo(
        () => ({
            ...baseStyle,
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {})
        }),
        [isDragReject, isDragAccept]
    );

    var errorMessage;

    /**
     * 
     * 戻るボタン押下時の処理
     * 
     */
    const onBackClick = () => {
        props.onCancel();
    }

    /**
     * 
     * 保存ボタン押下時の処理
     * 
     */
    const onSubmit = () => {
        var csvJson = [];

        // 文字化けしないようにエンコードする
        const file = acceptedFiles[0];
        const reader = new FileReader();
        reader.onload = (e) => {
            const codes = new Uint8Array(e.target.result);
            const encoding = Encoding.detect(codes);
            const unicodeString = Encoding.convert(codes, {
                to: 'unicode',
                from: encoding,
                type: 'string',
            });
            // CSVを解析
            Papa.parse(unicodeString, {
                header: false,          // 1行目をヘッダーとして扱わない
                dynamicTyping: false,   // Number型として取得しない
                skipEmptyLines: true,   // 空行は無視
                complete: (results) => {
                    // 解析したCSVをJSON化
                    results.data.forEach(row => (
                        csvJson.push({
                            'division': row[0],                 // 区分
                            'shop_name': row[1],                // 店舗名
                            'shop_f_name': row[2],              // 店舗名（フリガナ）
                            'shop_e_name': row[3],              // 店舗名（英字表記）
                            'shop_postal_cd': row[4],           // 郵便番号
                            'shop_address': row[5],             // 住所
                            'shop_e_address': row[6],           // 住所（英字表記）
                            'shop_latitude': row[7],            // 緯度
                            'shop_longitude': row[8],           // 経度
                            'shop_tel': row[9],                 // 電話番号
                            'shop_fax': row[10],                // FAX番号
                            'shop_deals': row[11],              // お得な情報
                            'shop_type': row[12],               // 店舗形態
                            'shop_cd_3': row[13],               // 店舗識別コード（レベル３）
                            'terminal_type': row[14],           // 端末タイプ
                            'terminal_model_cd': row[15],       // 機種コード
                            'terminal_apply_start_dt': row[16], // 有効日付（開始）
                            'terminal_apply_stop_dt': row[17],  // 有効日付（終了）
                            'terminal_charge_flg': row[18],     // チャージフラグ
                            'terminal_install_id': row[19],     // 機器設置時識別番号
                            'shop_cd_4': row[20],               // 店舗識別コード（レベル４）
                            'merchant_org_info': row[21],       // 独自識別情報
                        })
                    ))
                    // 店舗情報を保存
                    shopActions.upload(token, props.merchantId, csvJson)
                        .then(data => {
                            // 登録メッセージ表示
                            notificationActions.showSuccess('登録しました。');
                            // 店舗一覧画面に遷移
                            props.onCancel();
                        })
                        .catch(e => {
                            notificationActions.showError(e.message);
                        });
                },
            });
        };
        reader.readAsArrayBuffer(file);
    }

    const files = acceptedFiles.map(file => (
        <li>{file.path}</li>
    ));

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Toolbar variant="regular">
                    <div>
                        <Typography component="h1" variant="inherit">店舗一括登録</Typography>
                    </div>
                </Toolbar>

                <div {...getRootProps({ className: "dropzone", style })}>
                    <input {...getInputProps()} />
                    <p>
                        ここにファイルをドラッグ＆ドロップ
                        <br />
                        もしくは、クリックして選択
                    </p>
                </div>
                <aside>
                    <h4>ファイル</h4>
                    <ul>{files}</ul>
                </aside>

                <div>
                    <p>
                        {errorMessage}
                    </p>
                </div>

                <form className={classes.form} noValidate>
                    <Grid container spacing={2}>
                        <Grid container item xs={12} spacing={2} justify="center">
                            <Grid item xs={3} sm={6}>
                                <Button fullWidth variant="contained" size="medium"
                                    startIcon={<ArrowBackIosIcon />}
                                    onClick={onBackClick}><FormattedMessage id="Button.Back" /></Button>
                            </Grid>
                            <Grid item xs={3} sm={6}>
                                <Button fullWidth variant="contained" size="medium" color="primary"
                                    onClick={handleSubmit(onSubmit)}
                                    endIcon={<SaveIcon />}><FormattedMessage id="Button.Save" /></Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(ShopBulkRegist);
